var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { dense: "", align: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [
              _c("sys-select-category-group", {
                attrs: {
                  model: _vm.form.category_group_id,
                  error: !!_vm.errors.category_group_id,
                  errors: _vm.errors.category_group_id,
                  label: "Categoria de turma*",
                  dense: "",
                },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.form, "category_group_id", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  "error-messages": _vm.errors.position,
                  label: "Posição*",
                  type: "number",
                  min: "0",
                  dense: "",
                },
                model: {
                  value: _vm.form.position,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "position", $$v)
                  },
                  expression: "form.position",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "d-flex", attrs: { cols: "12", sm: "3" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    small: "",
                    loading: _vm.saving,
                    disabled: _vm.saving,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.save()
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.form.id ? "Atualizar" : "Adicionar") + " "
                  ),
                ]
              ),
              _vm.form.id
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ml-1",
                      attrs: { small: "", text: "", disabled: _vm.saving },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.resetForm()
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "elevation-1 mt-2",
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          loading: _vm.loading,
          "hide-default-footer": true,
          "items-per-page": -1,
          dense: "",
          "no-data-text":
            "Nenhuma posição cadastrada para este tipo de carga horária.",
        },
        scopedSlots: _vm._u([
          {
            key: "item.category",
            fn: function ({ item }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      item.category_group
                        ? item.category_group.name
                        : item.category_group_id
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "", color: "primary" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.edit(item)
                      },
                    },
                  },
                  [_vm._v("mdi-pencil")]
                ),
                _c(
                  "v-icon",
                  {
                    attrs: { small: "", color: "error" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.confirmDelete(item)
                      },
                    },
                  },
                  [_vm._v("mdi-delete")]
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "420" },
          model: {
            value: _vm.showDelete,
            callback: function ($$v) {
              _vm.showDelete = $$v
            },
            expression: "showDelete",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "subtitle-1" }, [
                _vm._v("Excluir posição"),
              ]),
              _c("v-card-text", [
                _vm._v(" Excluir a posição da categoria "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.toDelete && _vm.toDelete.category_group
                        ? _vm.toDelete.category_group.name
                        : ""
                    )
                  ),
                ]),
                _vm._v("? "),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.deleting },
                      on: {
                        click: function ($event) {
                          _vm.showDelete = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        loading: _vm.deleting,
                        disabled: _vm.deleting,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.remove()
                        },
                      },
                    },
                    [_vm._v("Excluir")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("emc-alert-snackbar", {
        attrs: {
          show: !!_vm.message.length,
          message: _vm.message,
          color: _vm.error ? "error" : "success",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }